import axios from 'axios'
import {getAdminToken} from '../../auth/_requests'

const API_URL = process.env.REACT_APP_API_URL

const adminApi = axios.create({
  withCredentials: true
})

adminApi.interceptors.request.use((config) => {
  const token = getAdminToken()
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export interface MarketplaceAccountStats {
  account_id: string
  email: string
  name: string
  company_name: string
  marketplace_enabled: boolean
  marketplace_e2ee_modal_seen_at?: string | null
  is_locked: boolean
  listing_count: number
  live_count: number
  sold_count: number
  pending_count: number
  draft_count: number
  hidden_count: number
  rejected_count: number
  total_views: number
  total_messages: number
  listing_profile_count: number
  total_profile_count: number
}

export interface MarketplaceSummary {
  total_accounts: number
  total_listings: number
  total_live: number
  total_sold: number
  total_pending: number
  total_views: number
  total_messages: number
}

export interface MarketplaceStatsResponse {
  success: boolean
  summary: MarketplaceSummary
  accounts: MarketplaceAccountStats[]
}

export function getMarketplaceStats(): Promise<{data: MarketplaceStatsResponse}> {
  return adminApi.get(`${API_URL}/admin/marketplace/stats`)
}

export interface FailedListing {
  _id: string
  title: string
  price: number
  listing_type: string
  status: string
  error_message: string
  retry_count: number
  profile_ids: string[]
  account_id: string
  account_name: string
  account_email: string
  photo_urls: string[]
  created_at: string
  updated_at: string
}

export function getFailedListings(): Promise<{data: {success: boolean; listings: FailedListing[]; total: number}}> {
  return adminApi.get(`${API_URL}/admin/marketplace/failed-listings`)
}

export function retryAllFailed(): Promise<{data: {success: boolean; retried: number; errors: string[]; total: number}}> {
  return adminApi.post(`${API_URL}/admin/marketplace/retry-all-failed`)
}

export function retrySingleListing(listingId: string): Promise<{data: {success: boolean}}> {
  return adminApi.post(`${API_URL}/admin/marketplace/retry/${listingId}`)
}
